import React from "react";
import DevHeader from "./DevHeader";
import ProdHeader from "./ProdHeader";

const Header = () => {
  return <ProdHeader />;
};

export default Header;
